export default Object.freeze({
  HOT_CHANNELS: 'HOT_CHANNELS',
  PRIVATE_CHANNELS: 'PRIVATE_CHANNELS',
  PUBLIC_CHANNELS: 'PUBLIC_CHANNELS',
})
